import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../../../utils/PropTypesDefinitions'
import BodyFont from '../../../Theme/Fonts/Body'
import SmallBodyFont from '../../../Theme/Fonts/SmallBody'
import LinkProps from '../../../Link/LinkProps'
import PodcastEpisodeTeaserImage from './Image'

export type PodcastEpisodeTeaserProps = LinkProps &
    TestID & {
        /** the url of the image */
        imageUrl: string
        /** info for seo about imageUrl */
        alt?: string
        /** the headline text which is displayed under the image */
        headlineText: string
        /** the headline text which is displayed under the headline text */
        subHeadlineText: string
        /** the duration of the podcast */
        duration: string
        /** href string to navigate to the provided url (web only) */
        href?: string
        /** callback when the user presses on the teaser
         *
         * @TJS-type function
         */
        onPress?: () => void
    }

const PodcastEpisodeTeaser: FunctionComponent<PodcastEpisodeTeaserProps> = ({
    headlineText,
    subHeadlineText,
    href,
    onPress,
    imageUrl,
    alt,
    duration,
    testID,
    webRel,
}): ReactElement | null => {
    return (
        <Touchable onPress={onPress} href={href} testID={testID} webRel={webRel}>
            <Grid noExpand width={125}>
                <PodcastEpisodeTeaserImage imageUrl={imageUrl} alt={alt} duration={duration} />
                <Grid noExpand marginTop={5} marginBottom={1} height={48}>
                    <BodyFont color="onyx-5" numberOfLines={2} bold textAlign="center">
                        {headlineText}
                    </BodyFont>
                </Grid>
                <SmallBodyFont color="keshi-3" numberOfLines={1} textAlign="center">
                    {subHeadlineText}
                </SmallBodyFont>
            </Grid>
        </Touchable>
    )
}

export default PodcastEpisodeTeaser
